import { makeAutoObservable } from 'mobx';
import localStorage from '../utils/localStorage';

class UserStore {
  constructor({ api }) {
    this.api = api;
    this.isAuthorized = localStorage.accessToken;
    this.updateFromLocalStorage = new Date().getTime();
    this.unreadNotification = 0;
    makeAutoObservable(this, {
      api: false,
    });
  }

  setIsAuthorized = value => {
    this.isAuthorized = value;
  };

  setUnreadNotification = value => {
    const n = Number(value) || 0;
    this.unreadNotification = Math.max(0, n);
  };

  decUnreadNotification = (delta = 1) => {
    this.unreadNotification = Math.max(0, this.unreadNotification - delta);
  };

  /**
   * Used to trigger cross-component event to update states from localStorage.
   */
  setUpdateFromLocalStorage = () => {
    this.updateFromLocalStorage = new Date().getTime();
  };
}

export default UserStore;
